export const loginRouterService = async (user) => {
  let route;
  switch (user.role_id) {
    case 1:
      return (route = "/home/admin_panel");

    case 2:
      return (route = "/home/food_order");

    case 3:
      return (route = "/home/cashier");

    default:
      return (route = "/home/food_order");
  }
};
